import { render } from "./Activities.vue?vue&type=template&id=2310d72e&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=2310d72e&lang=stylus"
import "./Activities.vue?vue&type=style&index=1&id=2310d72e&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2310d72e"]])

export default __exports__